export default {
  emailSmtp(state) {
    return state.emailSmtp
  },
}
